import { render, staticRenderFns } from "./SupportCategoryEditForm.vue?vue&type=template&id=1acce78c&"
import script from "./SupportCategoryEditForm.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryEditForm.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports